import React from 'react';
import type IViewPortData from './ViewPortData';

/**
 * Viewport Context refers to current viewport. Stores screen width and height parameters.
 * Defaulted to Mobile View keeping in mind adaptive responsive design.
 */

const MOBILE_MAX_WIDTH = 620;
const MOBILE_MAX_HEIGHT = 900;

const defaultData: IViewPortData = {
  width: MOBILE_MAX_WIDTH,
  height: MOBILE_MAX_HEIGHT,
};

const ViewportContext = React.createContext(defaultData);

export default ViewportContext;
